<template lang="pug">
  
  transition(
    @enter="enter" 
    @leave="leave" 
    :css="false" 
  )
    
    section#home-two-star(v-show="show").section.align-left 
      
      .headline-wrap( ref="headline" )
        img(src="@/assets/imgs/1x1.png" :alt="lang_en['home-star-rating-two-image-description']")
        stars( ref="stars" :show="showStars" )
        h1( 
          ref="title" 
          v-html="copy"  
          tabindex="-1"
        ).headline
 
        outline-btn( 
          ref="button" 
          :copy="lang_en['home-star-rating-two-cta']" 
          :url="section.route" 
          :hideOutline="hideOutline"
          :aria-label="lang_en['home-aria-read-more-two-star-button']"
          ).cta

</template> 

<script>

import gsap from 'gsap' 
import { mapState, mapMutations, mapGetters } from 'vuex'
import { PATHS, HOME } from 'src/config/app' 
import Env from 'src/config/env' 
import { map } from '@/helpers/MathUtils'
import BaseSectionMixin from '@/components/home/sections/mixins/BaseSection'
import OutlineBtn from '@/components/common/OutlineBtn'  
import Stars from '@/components/home/Stars'  

export default {
 
  mixins: [BaseSectionMixin],

  components: {
    Stars
  },

  data() {
    return { 
    }
  },

  created(){ },

  computed: {

    ...mapState('app', [ 'motion_clamp' ]),
    ...mapGetters('app', ['getSectionById']),

    copy(){
      return this.lang_en['home-star-rating-two-headline']
    },

    ctaCopy(){
      return this.lang_en['home-read-more-btn']
    },
    
    section(){ 
      return this.getSectionById(HOME.SECTIONS.STAR_RATING_TWO)
    },

    hideOutline(){
      return Env.mobile
    }
  },

  mounted() { },

  beforeDestroy() {},

  methods: {

    killTweens(){
      gsap.killTweensOf([this.$refs.title, this.$refs.button, this.$refs.stars.$el, this.$refs.headline])
    },
 
    enter(el, done){ 

      this.killTweens()

      done()

      const ww = window.innerWidth
      const wh = window.innerHeight
      const m = Env.mobile 

      const duration = ( (this.base_duration * 0.75) * this.motion_clamp )
      const delay = ( (this.base_duration * 0.5) * this.motion_clamp )
 
      gsap.fromTo(this.$refs.headline, {
        z: -(m ? (wh * 0.32) : (ww * 0.2)),
        x: (m ? (wh * 0.05) : (ww * 0.2)),
        y: (this.dir === 1) ? (wh * 0.5) : -(wh * 0.5),
        rotationY: -30,
        rotationX: 0
      }, {
        z: 0,
        x: 0,
        y: 0,
        opacity: 1,
        rotationY: 0,
        rotationX: 0, 
        duration: duration, 
        delay: delay, 
        ease: 'expo.out'
      })
 
      this.showButton()
      this.showStars = true
      gsap.delayedCall( (delay + duration) * 0.7, this.onEnterComplete)
    },

    leave(el, done){
 
      this.killTweens()

      const ww = window.innerWidth
      const wh = window.innerHeight
      const m = Env.mobile
      const rotMult = m ? 0.25 : 1
      const opacityMult = m ? 0.85 : 1

      gsap.to(this.$refs.headline, {
        z: (m ? (wh * 0.2) : (ww * 0.05)),
        x: -(m ? (ww * 0.2): (ww * 0.4)),
        y: (this.dir === 1) ? (m ? -(ww * 0.29) : 5) : (m ? (ww * 0.29) : 5),
        rotationY: -50,
        rotationX: 0, 
        ease: 'expo.in',
        duration: ((this.base_duration * 0.5) *  this.motion_clamp),
        onComplete: () => {
          const span = this.$refs.title.querySelector('strong')
          span.style.color = 'white'
          this.$refs.button.leave()
          done()
          this.showStars = false 
        }
      })

      gsap.to(this.$refs.headline, {
        duration: ( (this.base_duration * 0.5 * this.opacityMult) * this.motion_clamp),
        opacity: 0, 
        ease: 'power3.in' 
      }) 
 
 
    }
  },

  watch: { },

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

</style>
